// The app shell scrolls inside <main> (see components/ui/app.js), not the
// window — so window.scrollTo / window.scrollY no longer move or read the page.
// Use these helpers instead; they fall back to the window when no shell exists
// (e.g. standalone/public pages).
const SCROLLER_SELECTOR = '#app-container > main, #app-kp-container > main'

function getAppScroller() {
  return (
    document.querySelector(SCROLLER_SELECTOR) ||
    document.scrollingElement ||
    document.documentElement
  )
}

function isRootScroller(el) {
  return el === document.scrollingElement || el === document.documentElement
}

function scrollAppTo(options) {
  getAppScroller().scrollTo(options)
}

// Scroll so `target` sits `offset` px below the top edge of the scroll area.
function scrollAppToElement(target, {offset = 0, behavior = 'smooth'} = {}) {
  if (!target) return
  const scroller = getAppScroller()
  const scrollerTop = isRootScroller(scroller)
    ? 0
    : scroller.getBoundingClientRect().top
  const top =
    target.getBoundingClientRect().top -
    scrollerTop +
    scroller.scrollTop -
    offset
  scroller.scrollTo({top, behavior})
}

export {getAppScroller, scrollAppTo, scrollAppToElement}
